module.exports = __webpack_public_path__ + "static/media/estilosos_masculino_sapatos.7da04786.jpg";